<template>
  <div>
    <v-progress-linear :indeterminate="loadingCaseForms" v-if="loadingCaseForms"></v-progress-linear>
    <v-form v-model="valid" v-if="!loadingCaseForms">
      <v-layout row wrap align-center>

        <v-flex xs4>
          <v-subheader class="required">Client salutation:</v-subheader>
        </v-flex>

        <v-flex xs8>
          <v-select
            label="Salutation"
            v-model="localMainForm.salutation"
            :items="[
              'Mr',
              'Miss',
              'Mrs',
              'Mdm',
              'Dr'
            ]"/>
        </v-flex>

        <v-flex xs4>
          <v-subheader class="required">Relationship with deceased:</v-subheader>
        </v-flex>

        <v-flex xs8>
          <v-select
            label="Relationship with deceased"
            v-model="localMainForm.relationship_with_deceased"
            :rules="relationshipWithDeceasedRules"
            :items="[
              'Husband',
              'Wife',
              'Son',
              'Daughter',
              'Father',
              'Mother',
              'Father in law',
              'Mother in law',
              'Son in law',
              'Daughter in law',
              'Brother',
              'Sister',
              'Brother in law',
              'Sister in law',
              'Uncle',
              'Auntie',
              'Nephew',
              'Niece',
              'Cousin',
              'Friend',
              'Social worker',
              'Others'
            ]"></v-select>
        </v-flex>

        <v-flex xs12>
          <h3 style="margin-bottom: 20px; margin-top: 20px;">Deceased's Details</h3>
        </v-flex>

        <v-flex xs4>
          <v-subheader class="required">Date of Death:</v-subheader>
        </v-flex>

        <v-flex xs8>
          <v-menu>
            <v-text-field
              v-model="localMainForm.deceased_date"
              slot="activator"
              readonly
              :rules="dateRules"
            ></v-text-field>
            <v-date-picker v-model="localMainForm.deceased_date" reactive></v-date-picker>
          </v-menu>
        </v-flex>

        <v-flex xs4>
          <v-subheader class="required">Deceased Gender:</v-subheader>
        </v-flex>

        <v-flex xs8>
          <v-select v-model="localMainForm.deceased_gender" :items="['M', 'F']" :rules="genderRules"></v-select>
        </v-flex>

        <v-flex xs4>
          <v-subheader class="required">Deceased Name:</v-subheader>
        </v-flex>

        <v-flex xs8>
          <v-text-field v-model="localMainForm.deceased_name" :rules="deceasedNameRules"></v-text-field>
        </v-flex>

        <v-flex xs4>
          <v-subheader>Deceased Chinese Name:</v-subheader>
        </v-flex>

        <v-flex xs8>
          <v-text-field v-model="localMainForm.deceased_name_chinese"></v-text-field>
        </v-flex>

        <v-flex xs4>
          <v-subheader class="required">Deceased Age:</v-subheader>
        </v-flex>

        <v-flex xs8>
          <v-text-field v-model="localMainForm.deceased_age" type="number" :rules="ageRules"></v-text-field>
        </v-flex>

        <v-flex xs4>
          <v-subheader>Death Certificate No:</v-subheader>
        </v-flex>

        <v-flex xs8>
          <v-text-field v-model="localMainForm.deceased_death_certificate_no"></v-text-field>
        </v-flex>

        <v-flex xs4>
          <v-subheader class="required">Religion:</v-subheader>
        </v-flex>

        <v-flex xs8>
          <v-select v-model="localMainForm.deceased_religion" :items="[
            'Buddhist',
            'Taoist',
            'Catholic',
            'Christian',
            'Free thinker',
            'Hindu',
            'Soka',
            'Others'
          ]" :rules="religionRules"></v-select>
        </v-flex>

        <v-flex xs4>
          <v-subheader class="required">Dialect:</v-subheader>
        </v-flex>

        <v-flex xs8>
          <v-select v-model="localMainForm.deceased_dialect" :items="[
            'Cantonese',
            'Hainanese',
            'Hakka',
            'Hokchew',
            'Hokkien',
            'Kerk',
            'Shanghainese',
            'Tamil',
            'Teochew',
            'Others'
          ]" :rules="dialectRules"></v-select>
        </v-flex>

        <v-flex xs4>
          <v-subheader class="required">Location of Wake:</v-subheader>
        </v-flex>

        <v-flex xs8>
          <v-text-field v-model="localMainForm.deceased_location_of_wake" :rules="locationOfWakeRules"></v-text-field>
        </v-flex>

        <v-flex xs4>
          <v-subheader>Crematorium / Burial Location:</v-subheader>
        </v-flex>

        <v-flex xs8>
          <v-select
            :items="burialLocations"
            v-model="localMainForm.deceased_burial_location"
            clearable
          ></v-select>
        </v-flex>

        <v-flex xs4>
          <v-subheader>Embalming:</v-subheader>
        </v-flex>

        <v-flex xs8>
          <v-checkbox
            v-model="localMainForm.deceased_embalming"
          ></v-checkbox>
        </v-flex>

        <v-flex xs12>
          <v-subheader>TERMS & CONDITIONS (<a @click="openDialog('en')" class="link">Click to Open and Read</a>)</v-subheader>
        </v-flex>

        <v-flex xs12 class="ph16">
          <v-checkbox
            v-model="localMainForm.terms"
            :rules="termsAndConditionsRules"
            label="I acknowledge that our funeral director has shown and clearly explained the terms and conditions of products and services. In addition, I confirm that I have fully understood and agree to the terms and conditions stated above."
            @change="openDialog('en')"
          ></v-checkbox> 
          <br />
        </v-flex>
      </v-layout>
    </v-form>

    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="dialog = false">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ dialogTitle }}</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <TermsInEnglish v-if="dialogLang === 'en'" />
        <TermsInMandarin v-else />
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import TermsInEnglish from '@/components/forms/TermsInEnglish'
  import TermsInMandarin from '@/components/forms/TermsInMandarin'

  import { mapGetters } from 'vuex'

  export default {
    components: { TermsInEnglish, TermsInMandarin },
    props: {
      caseid: {
        type: Number,
        required: true
      }
    },
    computed: {
      ...mapGetters({
        formData: 'getOnBoardClientFormAnswers',
        editable: 'isOnBoardClientFormAnswersEditable',
        loadingCaseForms: 'getLoadingFormsStatus'
      }),
      dialogTitle () {
        return this.dialogLang === 'en' ? 'Terms & Conditions' : ''
      }
    },
    watch: {
      valid (newVal) {
        this.$store.commit('updateMainOnBoardForm', this.localMainForm)
        this.$emit('valid:changed', newVal)
      },
      formData () {
        this.caseSelected = this.caseid
        this.localMainForm = this.formData.main_form
      }
    },
    data () {
      return {
        localMainForm: {},
        valid: false,
        caseSelected: null,
        items: [],
        dateRules: [
          v => !!v || 'Required'
        ],
        genderRules: [
          v => !!v || 'Required'
        ],
        deceasedNameRules: [
          v => !!v || 'Required'
        ],
        ageRules: [
          v => v >= 0 && v <= 120 || 'Age can be from 1 to 120',
          v => !!v || 'Required'
        ],
        deathCertificateNoRules: [
          v => !!v || 'Required'
        ],
        religionRules: [
          v => !!v || 'Required'
        ],
        dialectRules: [
          v => !!v || 'Required'
        ],
        locationOfWakeRules: [
          v => !!v || 'Required'
        ],
        burialLocations: [
          'Mandai Crematorium', 'Kong Meng San Phor Kark See Monastery', 'Tse Tho Aum Temple', 'Choa Chu Kang Cemetery Complex'
        ],
        relationshipWithDeceasedRules: [
          v => !!v || 'Required'
        ],
        termsAndConditionsRules: [
          v => !!v || 'Required'
        ],
        dialog: false,
        dialogLang: 'en'
      }
    },
    methods: {
      openDialog (lang) {
        this.dialogLang = lang
        this.dialog = true
      }
    },
    created () {
      // this[_.camelCase(item.input_id)] = item.answer
      // s.split(/(?=[A-Z])/).join('_').toLowerCase()
      this.localMainForm = this.formData.main_form
    }
  }
</script>

<style scoped>
.link {
  text-transform: uppercase;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// Forms.vue?6372b82d